import { render } from "./PointStudents.vue?vue&type=template&id=e99b9eea"
import script from "./PointStudents.vue?vue&type=script&lang=js"
export * from "./PointStudents.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\StudentManageSystem\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__